module.exports = __webpack_public_path__ + "img/PaymentDefault.0006be86.svg";